import { render, staticRenderFns } from "./TruckHistory.vue?vue&type=template&id=7c0b19cf&scoped=true"
import script from "./TruckHistory.vue?vue&type=script&lang=js"
export * from "./TruckHistory.vue?vue&type=script&lang=js"
import style0 from "./TruckHistory.vue?vue&type=style&index=0&id=7c0b19cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0b19cf",
  null
  
)

export default component.exports